/**
 * Portal Context - Shared state and authentication for Customer Portal
 */
import { createContext, useContext } from 'react';

// Customer Auth Context
export const CustomerAuthContext = createContext(null);

// Portal Settings Context
export const PortalSettingsContext = createContext(null);

// Custom hooks
export const useCustomerAuth = () => useContext(CustomerAuthContext);
export const usePortalSettings = () => useContext(PortalSettingsContext);

// Default settings
export const defaultSettings = {
  studio_name: 'Studio',
  studio_subtitle: 'Kundenportal',
  primary_color: '#c9a34e',
  secondary_color: '#CA8A04',
  background_gradient_from: '#f0fdf4',
  background_gradient_to: '#dcfce7',
  logo_url: null,
};

// API base URL
export const API = process.env.REACT_APP_BACKEND_URL + '/api';
